import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { createFunctionResult, FUNCTION_RESULT_STATUS, FunctionResult, IObjectKey, isObjectKey } from '@nova/common-interfaces';
import { FUNCTION_NAME, IInvoice } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService extends CommonService<IInvoice, IObjectKey> {
  protected override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_INSERT;
  protected override mergeFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_MERGE;
  protected override updateFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_UPDATE;
  protected override deleteFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_REMOVE;
  protected override getAllFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_GETALL;
  protected override getFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_GET;
  protected override getKeysFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_GETKEYS;
  protected getByCustomerFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_GETBYCUSTOMER;
  protected getByDateRangeFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_GETBYDATERANGE;
  protected markInvoicePaidFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_MARKPAID;
protected reinstateFunctionName: FUNCTION_NAME = FUNCTION_NAME.FINANCIAL_INVOICE_REINSTATE;
constructor(functions: Functions) {
    super(functions);
  }

  public async getByCustomer(key: IObjectKey | string): Promise<FunctionResult<IInvoice[]>> {
    this.isLoading(true);

  let myId = "";
    if (isObjectKey(key)) {
      console.log("service-get isObjectKey", key);
      myId = (key as IObjectKey).id;
    } else {
      myId = key as string;
    }

    return new Promise<FunctionResult<IInvoice[]>>((resolve, reject) => {
      const callable = httpsCallable<IObjectKey | string, FunctionResult<IInvoice[]>>(
        this.functions,
        this.getByCustomerFunctionName.toString()
      );
      callable(myId)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(createFunctionResult<IInvoice[] | null>(FUNCTION_RESULT_STATUS.ERROR, null));
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  public async getByDateRange(start: number, end: number): Promise<FunctionResult<IInvoice[]>> {
    this.isLoading(true);

    return new Promise<FunctionResult<IInvoice[]>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<IInvoice[]>>(
        this.functions,
        this.getByDateRangeFunctionName.toString()
      );
      callable({"start": start, "end": end})
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(createFunctionResult<IInvoice[] | null>(FUNCTION_RESULT_STATUS.ERROR, null));
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
  
  /**
   * Delete object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async reinstate(invoice_id: string): Promise<FunctionResult<IInvoice>> {
    this.isLoading(true);
    console.debug("Calling Function", this.reinstateFunctionName.toString());

    return new Promise<FunctionResult<IInvoice>>((resolve, reject) => {
      const callable = httpsCallable<string, FunctionResult<IInvoice>>(
        this.functions,
        this.reinstateFunctionName.toString()
      );
      callable(invoice_id)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
  
  public async markPaid(key: IObjectKey | string): Promise<FunctionResult<IInvoice>> {
    this.isLoading(true);

  let myId = "";
    if (isObjectKey(key)) {
      console.log("service-get isObjectKey", key);
      myId = (key as IObjectKey).id;
    } else {
      myId = key as string;
    }

    return new Promise<FunctionResult<IInvoice>>((resolve, reject) => {
      const callable = httpsCallable<IObjectKey | string, FunctionResult<IInvoice>>(
        this.functions,
        this.markInvoicePaidFunctionName.toString()
      );
      callable(myId)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(createFunctionResult<IInvoice[] | null>(FUNCTION_RESULT_STATUS.ERROR, null));
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
}
